export const languages = {
  uz: {
    name: "🇺🇿 O'zbekcha",
    translations: {
      yourName: "Ismingiz",
      namePlaceholder: "To'liq ismingizni kiriting",
      topic: "Taqdimot mavzusi",
      topicPlaceholder: "Taqdimot mavzusini kiriting",
      numSlides: "Slaydlar soni",
      slidesHelp: "3 dan 12 gacha slaydlarni tanlang",
      style: "Taqdimot uslubi",
      styles: {
        general: "Umumiy",
        business: "Biznes",
        education: "Ta'lim",
        tech: "Texnologiya"
      },
      language: "Til",
      generate: "Taqdimot yaratish",
      generating: "Yaratilmoqda...",
      download: "Yuklab olish",
      successMessage: "Muvaffaqiyatli yaratildi!",
      errorMessages: {
        slides: "Iltimos, 3 dan 12 gacha slaydlarni tanlang",
        general: "Xatolik yuz berdi. Qaytadan urinib ko'ring."
      },
      downloading: "Yuklanmoqda..."
    }
  },
  en: {
    name: "🇺🇸 English",
    translations: {
      yourName: "Your Name",
      namePlaceholder: "Enter your full name",
      topic: "Presentation Topic",
      topicPlaceholder: "Enter your presentation topic",
      numSlides: "Number of Slides",
      slidesHelp: "Choose between 3 and 12 slides",
      style: "Presentation Style",
      styles: {
        general: "General",
        business: "Business",
        education: "Education",
        tech: "Technology"
      },
      language: "Language",
      generate: "Generate Presentation",
      generating: "Generating...",
      download: "Download Presentation",
      successMessage: "Successfully generated!",
      errorMessages: {
        slides: "Please select between 3 and 12 slides",
        general: "Error occurred. Please try again."
      },
      downloading: "Downloading..."
    }
  },
  ru: {
    name: "🇷🇺 Русский",
    translations: {
      yourName: "Ваше имя",
      namePlaceholder: "Введите ваше полное имя",
      topic: "Тема презентации",
      topicPlaceholder: "Введите тему презентации",
      numSlides: "Количество слайдов",
      slidesHelp: "Выберите от 3 до 12 слайдов",
      style: "Стиль презентации",
      styles: {
        general: "Общий",
        business: "Бизнес",
        education: "Образование",
        tech: "Технологии"
      },
      language: "Язык",
      generate: "Создать презентацию",
      generating: "Создание...",
      download: "Скачать презентацию",
      successMessage: "Успешно создано!",
      errorMessages: {
        slides: "Пожалуйста, выберите от 3 до 12 слайдов",
        general: "Произошла ошибка. Пожалуйста, попробуйте снова."
      },
      downloading: "Скачивание..."
    }
  }
};

export const defaultLanguage = 'uz'; 